export const SUGGESTED = [
    "🪣 Misc",
    "🏥 Health",
    "🚗 Cars",
    "🌟 Goals",
    "📈 Fundraising",
    "© Business Ideas",
    "📚 Research",
    "🤐 Secret Project",
    "💼 Client Work",
    "📣 Marketing",
    "🏡 Garden",
    "😍 Date Nights",
    "🗑 Catch All",
    "🎁 Gifts",
    "🐕 Pets",
    "🎉 Celebrations",
    "🎨 Art Projects",
    "🌳 Redo the Deck",
"👶 Child Care",
    "📖 Book Club",
    "🌱 Climate",
    "🎸 Music",
    "📸 Photography",
    "🍳 Recipes",
    "🚀 Space",
    "🤖 DIY",
    "🧳 Travel Plans",
    "📅 Event Planning",
    "🌍 Languages",
    "🎭 Theater",
    "🏋️‍♂️ Fitness Goals",
    "🧘‍♀️ Yoga & Meditation",
    "🌼 Hobbies",
    "👩‍💻 Coding Projects",
    "🎥 Movie Lists",
    "🛍 Shopping",
    "📈 Stocks",
    "🍜 Food Exploration",
    "👟 Sneaker Collection",
    "🛠 DIY Projects",
    "🎨 Craft Ideas",
    "🛫 Adventure Planner",
    "🏆 Achievements",
    "🍂 Seasonal Activities",
    "👻 Spooky Ideas",
    "🎅 Holiday Prep",
    "🔮 Future Plans",
    "💡 Inspirations",
    "📮 Pen Pals",
    "🕹 Retro Games",
    "👩‍🎤 Concerts",
    "🛏 Bedroom Redesign",
    "🚴 Cycling Routes",
    "🌟 Wish List",
    "👨‍👩‍👧 Family Time",
    "👩‍🔬 Science Experiments",
    "🚜 Farming",
    "🌸 Gardening Ideas",
    "📹 Content",
    "🌌 Astronomy",
    "🎒 School Projects",
    "🎯 Skill Building",
    "🚂 Model Trains",
    "📜 Historical Research",
];
